var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('DataGetter',{staticClass:"m-block m-block--charts m-block--charts-half indicators-wrapper",attrs:{"url":`${_vm.apiRoute}/dashboard`,"params":{
      region: _vm.selectedRegion,
      /*publication,*/
      product: 'Renewable heat',
    },"initialData":[
        'Share of renewables in heat consumption',
        'Share of electricity in heat consumption',
      ].reduce(
        (flows, flow) => [
          ...flows,
          { flow: `${flow}, Industry`, value: 0, year: 2022 },
          { flow: `${flow}, Industry`, value: 0, year: 2028 },
          { flow: `${flow}, Buildings`, value: 0, year: 2022 },
          { flow: `${flow}, Buildings`, value: 0, year: 2028 },
        ],
        []
      )},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('IndicatorBox',{attrs:{"title":`Industry heat indicators, ${_vm.selectedRegion}`,"indicators":data
          .filter((row) => row.flow.includes('Industry'))
          .sort((a, b) => {
            const flowNameA = a.flow.replace(', Industry', '');
            const flowNameB = b.flow.replace(', Industry', '');
            return flowNameA === flowNameB
              ? a.year - b.year
              : _vm.indicatorFlows.indexOf(flowNameA) -
                  _vm.indicatorFlows.indexOf(flowNameB);
          })
          .map((row) => ({
            title: `${row.flow.replace(', Industry', '')}, ${row.year}`,
            number: parseInt(row.value),
            units: '%',
            description: row.year === 2028 ? 'Forecast' : null,
          })),"compact":""}}),_c('IndicatorBox',{attrs:{"title":`Buildings heat indicators, ${_vm.selectedRegion}`,"indicators":data
          .filter((row) => row.flow.includes('Buildings'))
          .sort((a, b) => {
            const flowNameA = a.flow.replace(', Buildings', '');
            const flowNameB = b.flow.replace(', Buildings', '');
            return flowNameA === flowNameB
              ? a.year - b.year
              : _vm.indicatorFlows.indexOf(flowNameA) -
                  _vm.indicatorFlows.indexOf(flowNameB);
          })
          .map((row) => ({
            title: `${row.flow.replace(', Buildings', '')}, ${row.year}`,
            number: parseFloat(parseFloat(row.value).toFixed(0)),
            units: '%',
            description: row.year === 2028 ? 'Forecast' : null,
          })),"notes":_vm.countryNotes[_vm.selectedRegion],"compact":""}})]}}])}),_c('ControlGroup',[_c('DataGetter',{attrs:{"url":`${_vm.endpoint}/list/sector`,"initialData":[],"childElementType":null},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('ButtonGroup',{attrs:{"label":"Sector","options":data.map((value) => ({ label: value, value }))},model:{value:(_vm.selectedSector),callback:function ($$v) {_vm.selectedSector=$$v},expression:"selectedSector"}})]}}])})],1),_c('DataGetter',{attrs:{"url":_vm.endpoint,"params":{
      region: _vm.selectedRegion,
      publication: _vm.publication,
      sector: _vm.selectedSector,
      product: [
        ..._vm.heatProducts,
        'Share of modern renewables in heat consumption',
      ],
    },"childElementType":null,"initialData":[]},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('DataSlicer',{staticClass:"m-block m-block--charts m-block--charts-half",attrs:{"data":data,"xAxisDimension":"year","yAxisDimension":"product","valueDimension":"value"},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData }){return [_c('FiveYearChart',{attrs:{"title":`5-year consumption growth, ${_vm.selectedSector}`,"selectedRegion":_vm.selectedRegion,"products":_vm.heatProducts,"productLabel":"Heating technology","periods":[
          [2017, 2022],
          [2023, 2028],
        ],"showAll":"","computeGrowth":"","data":data}}),_c('ChartLayout',{attrs:{"title":`Renewable heat consumption, ${_vm.selectedSector.toLowerCase()}, ${_vm.selectedRegion}`,"units":"PJ","half":""},scopedSlots:_vm._u([(_vm.noteBySector[_vm.selectedSector])?{key:"notes",fn:function(){return [_c('p',[_vm._v(" "+_vm._s(_vm.noteBySector[_vm.selectedSector])+" ")])]},proxy:true}:null],null,true)},[_c('Chart',{key:"flowByYear",attrs:{"options":_vm.buildOptions(
              {
                chart: {
                  height: 480,
                },
                series: (slicedData || [])
                  .map((series) =>
                    series.name ===
                    'Share of modern renewables in heat consumption'
                      ? {
                          ...series,
                          type: 'line',
                          colorIndex: 8,
                          yAxis: 1,
                          connectNulls: true,
                          marker: { enabled: true },
                          tooltip: {
                            valueSuffix: '%',
                          },
                          zIndex: 99,
                        }
                      : {
                          ...series,
                          colorIndex: _vm.heatProducts.indexOf(series.name),
                        }
                  )
                  .toSorted(
                    (a, b) =>
                      _vm.heatProducts.indexOf(a.name) -
                      _vm.heatProducts.indexOf(b.name)
                  ),
                yAxis: [
                  {
                    title: { text: 'Total consumption' },
                    reversedStacks: false,
                    plotLines: [
                      {
                        value: 0,
                        className: 'highcharts-zero-axis',
                        zIndex: 99,
                      },
                    ],
                  },
                  {
                    title: { text: 'Renewable share' },
                    opposite: true,
                    min: 0,
                    labels: {
                      format: '{value}%',
                    },
                  },
                ],
                xAxis: {
                  plotBands: [
                    {
                      from: _vm.projectionYear - 0.5,
                      to: 2050,
                      label: {
                        text: 'Forecast',
                      },
                    },
                  ],
                },
                tooltip: {
                  valueSuffix: ' PJ',
                },
                legend: {
                  enabled: true,
                  align: 'right',
                  verticalAlign: 'middle',
                  layout: 'vertical',
                  width: '20%',
                  floating: false,
                  reversed: true,
                },
              },
              'column'
            ),"updateArgs":[true, true, true]}})],1)]}}],null,true)})]}}])}),_c('TextContent',{attrs:{"product":"Renewable heat","region":_vm.selectedRegion,"apiRoute":_vm.apiRoute,"publication":_vm.publication}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }